export default __webpack_public_path__ + "static/media/A&Bkhatadifference.6e117024.png";